export const legacyRoutes = {
  list: '/admin/legacy-job',
  add: '/admin/legacy-job/add',
  edit: '/admin/legacy-job/:itemId',
  getEditLink: (itemId: string) => `/admin/legacy-job/${itemId}`,
};
